import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const AddEmployeesService = {
  getAll: async () => {
    const res = await axios.get(ENDPOINT.AddEmployees);
    return res.data;
  },

  getById: async (id) => {
    const res = await axios.get(`${ENDPOINT.AddEmployees}/${id}`);
    return res.data;
  },


  getByDepartment: async (department) => {
    const res = await axios.get(`${ENDPOINT.AddEmployees}/department/${department}`);
    return res.data;
  },
  

  create: async (data) => {
    const res = await axios.post(ENDPOINT.AddEmployees, data, {
  headers: {
  "Content-Type": "multipart/form-data",
}
    });
    return res.data;
  },

  update: async (id, data) => {
    const res = await axios.put(`${ENDPOINT.AddEmployees}/${id}`, data, {
headers: {
  "Content-Type": "multipart/form-data",
}
    });
    return res.data;
  },

  remove: async (id) => {
    const res = await axios.delete(`${ENDPOINT.AddEmployees}/${id}`);
    return res.data;
  },
};